import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getStoreConfigurations: EvokeAction<AppState, AppActions> = async store => {
  try {
    const storeConfigurations = await api.get(`store-configurations`);
    console.log("storeConfigurations....",storeConfigurations)
    await store.update(state => {
      state.storeConfigurations = storeConfigurations;
    });
  } catch (error) {
    console.log("error...", error);
  }
};

const createStoreConfiguration: EvokeAction<AppState, AppActions> = async (
  store,
  values: Array<object>
) => {
  try {
    await api.post(
      `store-configurations`,
      {},
      values
    );

    // await store.update((state) => {
    //   if (state.posConfigurations !== undefined) {
    //     state.posConfigurations[posConfigurations.config_id] = posConfigurations;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const updateStoreConfiguration: EvokeAction<AppState, AppActions> = async (
  store,
  id:number,
  values: Array<object>
) => {
  try {
    await api.patch(
      `store-configurations/${id}`,
      {},
      values
    );

    // await store.update((state) => {
    //   if (state.posConfigurations !== undefined) {
    //     state.posConfigurations[posConfigurations.id] = posConfigurations;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const storeConfigurationActions = {
    getStoreConfigurations,
    createStoreConfiguration,
    updateStoreConfiguration
};